// 3rd party imports
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';

// bernie
import { ContextStore } from 'bernie-core';
import { ILocalization, LocalizedText, withLocalization } from '@shared-ui/localization-context';

// mobx
import { Quicklink } from 'models';

// ui
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkHeading, UitkText } from 'uitk-react-text';
import { UitkBanner } from 'uitk-react-banner';
import { UitkLink } from 'uitk-react-link';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkPrimaryButton } from 'uitk-react-button';
import { UitkCard, UitkCardContentSection } from 'uitk-react-cards';
import { UitkTextSkeleton } from 'uitk-react-skeleton';

// components
import { CustomQuicklink } from './custom-quicklink';
import { ConfiguredQuicklink } from './configured-quicklink';

// models
import ProgramStatus from 'stores/ProgramStatus';
import { Program, Product } from 'models';

// stores
import { UserAuthStore } from 'stores';

//util
import { modifyLocaleParam } from '../../util/LocaleParamTransformer';

export interface QuicklinksProps {
  context?: ContextStore;
  quicklinks?: Quicklink[];
  userAuth?: UserAuthStore;
  program?: Program;
  product?: Product;
  l10n?: ILocalization;
}

export interface QuicklinksState {
  loading: boolean;
}

@withLocalization
@inject('context', 'userAuth')
@observer
export class Quicklinks extends React.Component<QuicklinksProps, QuicklinksState> {
  private camref;
  private creativeref;
  private userProgramStatus;

  constructor(props) {
    super(props);

    this.camref = null;
    this.creativeref = null;
    this.userProgramStatus = null;

    this.state = {
      loading: true,
    };
  }

  private userProgramByBrandAndPosa = (programDetails) => {
    const userProgramRelationships = this.props.userAuth.userProgramRelationships;
    const userInfo = this.props.userAuth.currentUser;
    const userId = userInfo && userInfo.email ? userInfo.email : null;

    let candidateUserProgram = null;
    if (userProgramRelationships && userProgramRelationships.body.filter) {
      candidateUserProgram = userProgramRelationships.body.filter((userProgramRelationship) => {
        return (
          userProgramRelationship.id.brand === programDetails.brand &&
          userProgramRelationship.id.posa === programDetails.posa &&
          userProgramRelationship.id.userId === userId
        );
      });
    }

    return candidateUserProgram;
  };

  private getUserProgramStatus(candidateUserProgram) {
    let programStatus = null;

    if (candidateUserProgram && candidateUserProgram.length) {
      const userProgram = candidateUserProgram[0];
      programStatus = userProgram.affiliatePartnership.partnershipStatus;
    } else {
      programStatus = null;
    }

    return programStatus;
  }

  private getUserCamRef = (candidateUserPrograms) => {
    if (candidateUserPrograms && candidateUserPrograms.length) {
      const userProgram = candidateUserPrograms[0];

      return userProgram.programReference;
    }
  };

  private renderJoinNowBanner() {
    const candidateUserProgram = this.userProgramByBrandAndPosa(this.props.program);
    this.camref = this.getUserCamRef(candidateUserProgram);
    this.userProgramStatus = this.getUserProgramStatus(candidateUserProgram);

    const pzSignUpPageLink = `/${modifyLocaleParam(this.props.context.locale)}/pz-signup?programName=${
      this.props.program.name
    }`;
    const programsPageLink = `/${modifyLocaleParam(this.props.context.locale)}/programs`;
    const productPageLink = `/${modifyLocaleParam(this.props.context.locale)}/products?programName=${
      this.props.program.name
    }`;
    const productPageLinkText = this.props.program.title;

    if (this.userProgramStatus === ProgramStatus.UNKNOWN || this.userProgramStatus == null) {
      return (
        <UitkSpacing margin={{ blockend: 'six' }}>
          <div>
            <UitkSpacing margin={{ blockend: 'four' }}>
              <div>
                <UitkBanner icon="info_outline" message={this.props.l10n.formatText('preview.products.banner.text')}>
                  <UitkLink inline={true}>
                    <Link to={pzSignUpPageLink} className="a--no-hover">
                      <LocalizedText message="preview.products.join.the.program" />
                    </Link>
                  </UitkLink>
                </UitkBanner>
              </div>
            </UitkSpacing>
            <UitkLayoutFlex justifyContent="space-between" alignItems="center">
              <UitkLayoutFlexItem>
                <UitkText>
                  <UitkLink inline={true}>
                    <Link to={programsPageLink} className="a--no-hover">
                      <LocalizedText message="programs.page.link" />
                    </Link>
                  </UitkLink>
                  &nbsp;{'>'}&nbsp;
                  <UitkLink inline={true}>
                    <Link to={productPageLink} className="a--no-hover">
                      {productPageLinkText}
                    </Link>
                  </UitkLink>
                  &nbsp;{'>'}
                </UitkText>
              </UitkLayoutFlexItem>
              <UitkLayoutFlexItem>
                <UitkPrimaryButton
                  type={'button'}
                  href={pzSignUpPageLink}
                  text={this.props.l10n.formatText('preview.products.join.the.program')}
                />
              </UitkLayoutFlexItem>
            </UitkLayoutFlex>
          </div>
        </UitkSpacing>
      );
    }
  }

  private generateQuickLink = (inputUrl) => {
    if (this.camref) {
      const camref = `/camref:${this.camref}`;
      const creativeref = this.props.product.creativeRef ? `/creativeref:${this.props.product.creativeRef}` : '';
      const destination = `/destination:${inputUrl}`;

      return `https://vrbo.prf.hn/click${camref}${creativeref}${destination}`;
    }
  };

  public componentDidMount() {
    setTimeout(() => {
      this.setState({
        loading: false,
      });
    }, 3500);
  }

  public render() {
    const { quicklinks, l10n, program } = this.props;

    const { loading } = this.state;
    const ConfiguredQuicklinks = ({ items, camRef }) => {
      const quicklinksList =
        items &&
        items.map((q) => {
          // Dynamic link param will be here
          const newUrl = this.generateQuickLink(q.link);
          const newCode = `<a href="${newUrl || q.link}">${q.text}</a>`;

          return (
            <ConfiguredQuicklink
              name={q.name}
              title={q.title}
              code={newCode}
              pzLink={newUrl || q.link}
              link={q.link}
              key={`ql-${q.name}`}
            />
          );
        });

      const quicklinksSkeleton =
        items &&
        items.map((q, i) => {
          return (
            <UitkSpacing margin={{ blockend: 'four' }} key={`skeleton-${i}`}>
              <UitkCard padded={true}>
                <UitkCardContentSection>
                  <UitkTextSkeleton />
                </UitkCardContentSection>
                <UitkCardContentSection>
                  <UitkTextSkeleton animation={true} type="secondary" />
                </UitkCardContentSection>
              </UitkCard>
            </UitkSpacing>
          );
        });

      return <>{loading ? quicklinksSkeleton : quicklinksList}</>;
    };

    return (
      <UitkSpacing className="container" padding={{ block: 'twelve' }}>
        <main>
          {this.renderJoinNowBanner()}
          <UitkSpacing margin={{ blockend: 'six' }}>
            <UitkHeading tag="h1" size={2}>
              {this.props.program.title + ' ' + l10n.formatText('products.deeplink.title')}
            </UitkHeading>
          </UitkSpacing>
          <CustomQuicklink camRef={this.camref} creativeRef={this.props.product.creativeRef} program={program}/>
          <UitkSpacing margin={{ blockend: 'one' }}>
            <UitkHeading tag="h2" size={4}>
              <LocalizedText message="products.quicklink.configured.title" />
            </UitkHeading>
          </UitkSpacing>
          <UitkSpacing margin={{ blockend: 'six' }}>
            <UitkText>
              <LocalizedText message="products.quicklink.configured.content" />
            </UitkText>
          </UitkSpacing>
          <ConfiguredQuicklinks items={quicklinks} camRef={this.camref} />
        </main>
      </UitkSpacing>
    );
  }
}
